// Initial State
const initialState = {
  paymentMode: "",
  standingInstruction: false,
  proposalId: "",
};

// Reducer
const athenaPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PAYMENT_MODE":
      return {
        ...state,
        paymentMode: action.payload,
      };
    case "SET_STANDING_INSTRUCTION":
      return {
        ...state,
        standingInstruction: action.payload,
      };
    case "SET_PROPOSAL_ID":
      return {
        ...state,
        proposalId: action.payload,
      };
    default:
      return state;
  }
};

// ✅ Action Creator (Keep this here)
export const setPaymentModeRedux = (mode) => ({
  type: "SET_PAYMENT_MODE",
  payload: mode,
});
export const setStandingInstructionRedux = (mode) => ({
  type: "SET_STANDING_INSTRUCTION",
  payload: mode,
});
export const setProposalIdRedux = (proposalId) => ({
  type: "SET_PROPOSAL_ID",
  payload: proposalId,
});
export default athenaPaymentReducer;
